'use strict';

var _ = require('lodash');
var AdvancedHepTransformationService = function AdvancedHepTransformationService(configurationService, fpMarketConfigParsingService, momentService, featureToggleService, configurationParametersAdvancedService) {
  var HOST_CARRIER = configurationService.getHostCarrier();
  var BENCHMARK_CARRIER_FIELD_PREFIX = 'cabinCode';
  var CABIN_CAPACITIES_FIELD_PREFIX = 'cabinCapacities';
  var OPERATOR_NUMBER_PROPS = {
    noOfStop: true,
    minConnectionTime: true,
    maxConnectionTime: true
  };
  var OPERATOR_BOOLEAN_PROPS = {
    isPOCandPOS: true,
    isCodeShare: true,
    isTOD: true,
    isOneWay: true,
    isShiftShopping: true,
    isUseNGDS: true,
    isDynamicPricingAdj: true,
    isMlModelEnabled: true,
    isFareBrandEnabled: true
  };
  var RIA_METHOD_MAP = {
    MEDIAN: 'Median',
    WEIGHTED_AVERAGE: 'Weighted Avg'
  };
  var MARKET_CONFIG_SOURCE_METHOD_MAP = {
    ALL: 'All',
    WEB_FARES: 'Web Fares'
  };
  function getBenchmarkFieldName(cabin) {
    return BENCHMARK_CARRIER_FIELD_PREFIX + cabin;
  }
  function getCabinCapacitiesFieldName(cabin) {
    return CABIN_CAPACITIES_FIELD_PREFIX + '-' + cabin;
  }
  function getCarriersForCabins(benchmarkCarriers) {
    var availableCabins = configurationService.getCabins();
    return _.transform(availableCabins, function (result, cabin) {
      result[getBenchmarkFieldName(cabin)] = getCarriersForCabin(benchmarkCarriers, cabin);
    }, {});
  }
  function getCarriersForCabin(benchmarkCarriers, cabin) {
    var carriersForCabin = _.find(benchmarkCarriers, function (obj) {
      return obj.attributes.cabinCode === cabin;
    });
    return _.isUndefined(carriersForCabin) ? null : carriersForCabin.properties.benchmarkCarriers;
  }
  function getMarketLevelCarriers(marketBenchmarkCarriers) {
    var availableCabins = configurationService.getCabins();
    return _.transform(availableCabins, function (result, cabin) {
      result[getBenchmarkFieldName(cabin)] = marketBenchmarkCarriers;
    }, {});
  }
  function transformBlackoutDatesArray(propertyValue) {
    return _.map(propertyValue, function (row) {
      fpMarketConfigParsingService.splitParsedDate(row, 'start');
      fpMarketConfigParsingService.splitParsedDate(row, 'end');
      return row;
    });
  }
  function transformDTDBlackoutArray(propertyValue) {
    return _.map(propertyValue, function (row) {
      fpMarketConfigParsingService.splitParsedNumber(row, 'dtdCondition');
      return row;
    });
  }
  function transformBoolean(booleanValue) {
    return booleanValue ? 'Yes' : 'No';
  }
  function transformRiaMethod(riaMethod) {
    return RIA_METHOD_MAP[riaMethod];
  }
  function transformMarketConfigSource(source) {
    return MARKET_CONFIG_SOURCE_METHOD_MAP[source];
  }
  function transformMarketConfigProperties(properties, propKey) {
    addDefaultValuesToDisplay(properties);
    return _.transform(properties, function (result, propertyValue, key) {
      key = key.split('-').join('_');
      var newKey = [propKey, key].join('_');
      if (OPERATOR_NUMBER_PROPS[key]) {
        result[newKey] = propertyValue;
        fpMarketConfigParsingService.splitParsedNumber(result, newKey);
      } else if (OPERATOR_BOOLEAN_PROPS[key]) {
        result[newKey] = transformBoolean(propertyValue);
      } else if (key === 'riaMethod') {
        result[newKey] = transformRiaMethod(propertyValue);
      } else if (key === 'source') {
        result[newKey] = transformMarketConfigSource(propertyValue);
      } else if (key === 'blackoutDeptDateParams') {
        result[newKey] = transformBlackoutDatesArray(propertyValue);
      } else if (key === 'dtdBlackout') {
        result[newKey] = transformDTDBlackoutArray(propertyValue);
      } else {
        result[newKey] = propertyValue;
      }
      return result;
    }, {});
  }
  function addDefaultValuesToDisplay(properties) {
    if (featureToggleService.isEnabled('DYNAMIC_PRICING')) {
      if (!_.has(properties, 'isDynamicPricingAdj')) {
        properties.isDynamicPricingAdj = false;
      }
      if (!_.has(properties, 'dynamicPricingAdjLOSRanges') || _.isEmpty(properties['dynamicPricingAdjLOSRanges'])) {
        properties.dynamicPricingAdjLOSRanges = [{
          losStart: 0,
          losEnd: 330
        }];
      }
    }
    if (featureToggleService.isEnabled('DYNAMIC_AVAILABILITY_ML_MODEL')) {
      if (!_.has(properties, 'isMlModelEnabled')) {
        properties.isMlModelEnabled = false;
      }
    }
  }
  function getBenchmarkCarrierProperties(attrs, benchmarkCarriersHepList) {
    var marketCabinBenchmarks = _.filter(benchmarkCarriersHepList, function (obj) {
      return _.get(obj, ['attributes', 'marketOrigin']) === attrs.marketOrigin && _.get(obj, ['attributes', 'marketDestination']) === attrs.marketDestination;
    });
    var marketBenchmarks = _.find(marketCabinBenchmarks, function (obj) {
      return _.get(obj, ['attributes', 'cabinCode']) === undefined;
    });
    if (marketCabinBenchmarks.length === 1 && marketBenchmarks !== undefined) {
      return getMarketLevelCarriers(marketBenchmarks.properties.benchmarkCarriers);
    } else {
      return getCarriersForCabins(marketCabinBenchmarks);
    }
  }
  function transformFpMarketConfigType(attrs, props, meta, benchmarkCarriersHepList) {
    var propKey = _.chain(props).keys().head().value();
    var properties = props[propKey];
    var transformedProperties = transformMarketConfigProperties(properties, propKey);
    var benchmarkCarrierProperties = getBenchmarkCarrierProperties(attrs, benchmarkCarriersHepList);
    return _.assign(transformedProperties, attrs, meta, benchmarkCarrierProperties);
  }
  function transformCurtainRuleType(attrs, props, meta) {
    var availableCabins = configurationService.getCabins();
    var propKey = _.chain(props).keys().head().value();
    var generatedProp = _.mapKeys(props[propKey], function (obj, key) {
      key = key.split('-').join('_');
      return [propKey, key].join('_');
    });
    _.forEach(generatedProp['curtainRuleParam_cabinOptions'], function (cabinOptionsRow) {
      _.forEach(availableCabins, function (cabinName) {
        if (!_.isNil(cabinOptionsRow[CABIN_CAPACITIES_FIELD_PREFIX][cabinName])) {
          var fieldName = getCabinCapacitiesFieldName(cabinName);
          cabinOptionsRow[fieldName] = cabinOptionsRow[CABIN_CAPACITIES_FIELD_PREFIX][cabinName];
        }
      });
    });
    return _.assign(generatedProp, attrs, meta);
  }
  function transformFOTacticalFareIndexType(attrs, props, meta) {
    var propKey = _.chain(props).keys().head().value();
    var foTacticalFareIndexProperties = _.map(props[propKey], function (foTacticalFareIndexProperty) {
      foTacticalFareIndexProperty.percentageIndicator = percentageIndicatorToString(foTacticalFareIndexProperty);
      return foTacticalFareIndexProperty;
    });
    props[propKey] = foTacticalFareIndexProperties;
    return transformAttributeNameToFOAttributeName(attrs, props, meta);
  }
  function transformFOFareBrandAssignment(attrs, props, meta) {
    return transformAttributeNameToFOAttributeName(attrs, props, meta);
  }
  function transformFORuleMappingDOW(attrs, props, meta) {
    return transformAttributeNameToFOAttributeName(attrs, props, meta);
  }
  function transformFORuleMappingAP(attrs, props, meta) {
    return transformAttributeNameToFOAttributeName(attrs, props, meta);
  }
  function transformFOSurchargeManagement(attrs, props, meta) {
    return transformAttributeNameToFOAttributeName(attrs, props, meta);
  }
  function transformFOTacticalUserOverridesType(attrs, props, meta) {
    var tacticalUserOverrideRows = [];
    _.forEach(props.tariffLevelProperties, function (tariffLevelProperty) {
      var tacticalUserOverrideRow = _.cloneDeep(attrs);
      tacticalUserOverrideRow.fareTariffNumber = tariffLevelProperty.fareTariffNumber;
      tacticalUserOverrideRow.cardinalityThreshold = tariffLevelProperty.cardinalityThreshold;
      tacticalUserOverrideRow.fareValidityThreshold = tariffLevelProperty.fareValidityThreshold;
      var foTacticalFareBrandUserOverrideProperties = tariffLevelProperty.foTacticalFareBrandUserOverrideProperties[0];
      tacticalUserOverrideRow.hostFareBrand = foTacticalFareBrandUserOverrideProperties.hostFareBrand;
      tacticalUserOverrideRow.foSeasons = foTacticalFareBrandUserOverrideProperties.seasons;
      if (!_.isNil(tariffLevelProperty.cardinalityThresholdPercentageIndicator)) {
        tacticalUserOverrideRow.cardinalityThresholdPercentageIndicator = tariffLevelProperty.cardinalityThresholdPercentageIndicator === true ? 'P' : 'A';
      }
      tacticalUserOverrideRow.proactiveBlackoutPropertiesList = [];
      if (!_.isNil(foTacticalFareBrandUserOverrideProperties.inboundProactiveBlackouts)) {
        tacticalUserOverrideRow.proactiveBlackoutPropertiesList = tacticalUserOverrideRow.proactiveBlackoutPropertiesList.concat(transformProactiveBlackoutsPropertiesToRender(foTacticalFareBrandUserOverrideProperties.inboundProactiveBlackouts, 'inboundProactiveBlackouts'));
      }
      if (!_.isNil(foTacticalFareBrandUserOverrideProperties.outboundProactiveBlackouts)) {
        tacticalUserOverrideRow.proactiveBlackoutPropertiesList = tacticalUserOverrideRow.proactiveBlackoutPropertiesList.concat(transformProactiveBlackoutsPropertiesToRender(foTacticalFareBrandUserOverrideProperties.outboundProactiveBlackouts, 'outboundProactiveBlackouts'));
      }
      tacticalUserOverrideRows.push(transformAttributeNameToFOAttributeName(_.assign(tacticalUserOverrideRow, meta)));
    });
    return tacticalUserOverrideRows;
  }
  function transformFOTacticalFareIndexPayload(row) {
    row.foTacticalFareIndexProperties = _.map(row.foTacticalFareIndexProperties, function (tacticalFareIndexProperty) {
      tacticalFareIndexProperty.percentageIndicator = percentageIndicatorToBoolean(tacticalFareIndexProperty);
      return tacticalFareIndexProperty;
    });
    return convertFOAttributeNameToAttributeName(row, 'foTacticalFareIndexProperties');
  }
  function transformFOFareBrandAssignmentPayload(row) {
    row.fareBrandAssignmentPropertiesList = _.map(row.fareBrandAssignmentPropertiesList, function (fareBrandAssignmentProperty) {
      fareBrandAssignmentProperty.fareBrand = fareBrandAssignmentProperty.fareBrand.toUpperCase();
      if (!_.isNil(fareBrandAssignmentProperty.inclusionFbcPattern)) {
        fareBrandAssignmentProperty.inclusionFbcPattern = fareBrandAssignmentProperty.inclusionFbcPattern.toUpperCase();
      }
      if (!_.isNil(fareBrandAssignmentProperty.exclusionFbcPattern)) {
        fareBrandAssignmentProperty.exclusionFbcPattern = fareBrandAssignmentProperty.exclusionFbcPattern.toUpperCase();
      }
      return fareBrandAssignmentProperty;
    });
    return convertFOAttributeNameToAttributeName(row, 'fareBrandAssignmentPropertiesList');
  }
  function transformFOTacticalFareDefinitionPayload(row) {
    _.forEach(row.tacticalFareDefinitionPropertiesList, function (tacticalFareBrandDefinitionProperty) {
      if ('RBD' === tacticalFareBrandDefinitionProperty.criteriaType.toUpperCase()) {
        tacticalFareBrandDefinitionProperty.value = tacticalFareBrandDefinitionProperty.value.toUpperCase();
      }
      if ((!_.isEmpty(tacticalFareBrandDefinitionProperty.compMatch) || !_.isNil(tacticalFareBrandDefinitionProperty.compMatch)) && 'PRIMARY' === tacticalFareBrandDefinitionProperty.grouping.toUpperCase()) {
        tacticalFareBrandDefinitionProperty.compMatch = null;
      }
    });
    return convertFOAttributeNameToAttributeName(row, 'tacticalFareDefinitionPropertiesList');
  }
  function transformFOTacticalFareDefinition(attrs, props, meta) {
    return transformAttributeNameToFOAttributeName(attrs, props, meta);
  }
  function transformFOApplicableDateMappingPayload(row) {
    _.forEach(row.applicableDateMappingProperties, function (applicableDateMappingProperty) {
      if ((!_.isEmpty(applicableDateMappingProperty.splitForStruc) || !_.isNil(applicableDateMappingProperty.splitForStruc)) && 'STRUCTURAL' === applicableDateMappingProperty.category.toUpperCase()) {
        applicableDateMappingProperty.splitForStruc = false;
      }
      removeAdditionalKeys(applicableDateMappingProperty, ['cabin', 'origin', 'destination', 'category', 'benchmarkFareComponent']);
    });
    return convertFOAttributeNameToAttributeName(row, 'applicableDateMappingProperties');
  }
  function transformFOApplicableDateMapping(attrs, props, meta) {
    var propKey = _.chain(props).keys().head().value();
    var applicableDateMappingProperties = [];
    _.forEach(props[propKey], function (applicableDateMapping) {
      var foApplicableDateMapping = {};
      foApplicableDateMapping.fareSource = applicableDateMapping.fareSource;
      foApplicableDateMapping.fareTariffNumber = applicableDateMapping.fareTariffNumber;
      foApplicableDateMapping.fareTypeIndicator = applicableDateMapping.fareTypeIndicator;
      foApplicableDateMapping.datesThreshold = applicableDateMapping.datesThreshold;
      foApplicableDateMapping.dates = applicableDateMapping.dates;
      foApplicableDateMapping.splitOnStruc = applicableDateMapping.splitOnStruc;
      foApplicableDateMapping.fbcPattern = applicableDateMapping.fbcPattern;
      foApplicableDateMapping.filedAmount = applicableDateMapping.filedAmount;
      foApplicableDateMapping.mappedApplDates = applicableDateMapping.mappedApplDates;
      if (!_.isNil(applicableDateMapping.hostCarrier) && !_.isEmpty(applicableDateMapping.hostCarrier)) {
        foApplicableDateMapping.hostCarrier = applicableDateMapping.hostCarrier;
      }
      foApplicableDateMapping.carrier = applicableDateMapping.carrier;
      foApplicableDateMapping.marketGroup = attrs.marketGroup;
      foApplicableDateMapping.marketType = attrs.marketType;
      foApplicableDateMapping.marketAnalyst = attrs.marketAnalyst;
      foApplicableDateMapping.marketCategory = attrs.marketCategory;
      foApplicableDateMapping.origin = attrs.origin;
      foApplicableDateMapping.destination = attrs.destination;
      foApplicableDateMapping.originCountry = attrs.originCountry;
      foApplicableDateMapping.destinationCountry = attrs.destinationCountry;
      foApplicableDateMapping.cabin = attrs.cabin;
      foApplicableDateMapping.category = attrs.category;
      applicableDateMappingProperties.push(foApplicableDateMapping);
    });
    props[propKey] = applicableDateMappingProperties;
    return transformAttributeNameToFOAttributeName(attrs, props, meta);
  }
  function transformFOFareBasisCodePatternPayload(row) {
    var fareBasisCodePatternRow = [];
    _.forEach(row.fareBasisCodePatternPropertyGroup, function (eachFareBasisCodePatternPropertyGroup) {
      var fareBasisCodePatternPropertyGroup = {};
      var fareBasisCodePatternProperties = [];
      _.forEach(eachFareBasisCodePatternPropertyGroup.fareBasisCodePatternProperties, function (eachFareBasisCodePatternProperty) {
        var fbcPattern = {};
        fbcPattern.property = eachFareBasisCodePatternProperty.property;
        fbcPattern.propertyValue = eachFareBasisCodePatternProperty.propertyValue;
        fbcPattern.fileRules = eachFareBasisCodePatternProperty.fileRules;
        fareBasisCodePatternProperties.push(fbcPattern);
      });
      fareBasisCodePatternPropertyGroup.fareSource = eachFareBasisCodePatternPropertyGroup.fareSource;
      fareBasisCodePatternPropertyGroup.fareTariffNumber = eachFareBasisCodePatternPropertyGroup.fareTariffNumber;
      fareBasisCodePatternPropertyGroup.order = eachFareBasisCodePatternPropertyGroup.order;
      fareBasisCodePatternPropertyGroup.fbcValue = eachFareBasisCodePatternPropertyGroup.fbcValue;
      if (_.isNil(eachFareBasisCodePatternPropertyGroup.fbcValueGroup) || eachFareBasisCodePatternPropertyGroup.fbcValueGroup === '') {
        eachFareBasisCodePatternPropertyGroup.fbcValueGroup = 0;
      }
      fareBasisCodePatternPropertyGroup.fbcValueGroup = eachFareBasisCodePatternPropertyGroup.fbcValueGroup;
      fareBasisCodePatternPropertyGroup.fareBasisCodePatternProperties = fareBasisCodePatternProperties;
      fareBasisCodePatternRow.push(fareBasisCodePatternPropertyGroup);
    });
    row.fareBasisCodePatternPropertyGroup = fareBasisCodePatternRow;
    removeAdditionalKeys(row, ['fareSource', 'fareTariffNumber', 'order', 'fbcValue', 'fbcValueGroup', 'fareBasisCodePatternProperties']);
    return convertFOAttributeNameToAttributeName(row, 'fareBasisCodePatternPropertyGroup');
  }
  function transformFOFareBasisCodePattern(attrs, props, meta) {
    var propKey = _.chain(props).keys().head().value();
    var fareBasisCodePatternRows = [];
    _.forEach(props[propKey], function (fareBasisCodePattern) {
      var fareBasisCodePatternRow = {};
      fareBasisCodePatternRow = _.cloneDeep(attrs);
      fareBasisCodePatternRow.fareSource = fareBasisCodePattern.fareSource;
      fareBasisCodePatternRow.fareTariffNumber = fareBasisCodePattern.fareTariffNumber;
      fareBasisCodePatternRow.order = fareBasisCodePattern.order;
      fareBasisCodePatternRow.fbcValue = fareBasisCodePattern.fbcValue;
      fareBasisCodePatternRow.fbcValueGroup = fareBasisCodePattern.fbcValueGroup;
      fareBasisCodePatternRow.fareBasisCodePatternProperties = buildFareBasisCodePatternProperties(fareBasisCodePatternRow, fareBasisCodePattern.fareBasisCodePatternProperties);
      if (_.isNil(attrs.hostCarrier) || _.isEmpty(attrs.hostCarrier)) {
        fareBasisCodePatternRow.hostCarrier = '';
      }
      if (_.isNil(fareBasisCodePattern.fbcValue) || _.isEmpty(fareBasisCodePattern.fbcValue)) {
        fareBasisCodePatternRow.fbcValue = '';
      }
      if (_.isNil(fareBasisCodePattern.fbcValueGroup) || fareBasisCodePattern.fbcValueGroup === '') {
        fareBasisCodePatternRow.fbcValueGroup = '0';
      }
      if (!_.isNil(attrs === null || attrs === void 0 ? void 0 : attrs.category)) {
        fareBasisCodePatternRow.adaptivePricingCategory = attrs.category;
      }
      fareBasisCodePatternRows.push(transformAttributeNameToFOAttributeName(_.assign(fareBasisCodePatternRow, meta)));
    });
    return fareBasisCodePatternRows;
  }
  function buildFareBasisCodePatternProperties(row, fbcProperties) {
    var fareBasisCodePatternProperties = [];
    _.forEach(fbcProperties, function (fbcPattern) {
      var fareBasisCodePatternRow = {};
      fareBasisCodePatternRow.property = fbcPattern.property;
      fareBasisCodePatternRow.propertyValue = fbcPattern.propertyValue;
      fareBasisCodePatternRow.fileRules = fbcPattern.fileRules;
      fareBasisCodePatternRow.hostCarrier = row.hostCarrier;
      fareBasisCodePatternRow.marketGroup = row.marketGroup;
      fareBasisCodePatternRow.marketType = row.marketType;
      fareBasisCodePatternRow.marketAnalyst = row.marketAnalyst;
      fareBasisCodePatternRow.marketCategory = row.marketCategory;
      fareBasisCodePatternRow.origin = row.origin;
      fareBasisCodePatternRow.originCountry = row.originCountry;
      fareBasisCodePatternRow.destination = row.destination;
      fareBasisCodePatternRow.destinationCountry = row.destinationCountry;
      fareBasisCodePatternRow.category = row.category;
      fareBasisCodePatternRow.cabin = row.cabin;
      fareBasisCodePatternRow.fareSource = row.fareSource;
      fareBasisCodePatternRow.fareTariffNumber = fbcPattern.fareTariffNumber;
      fareBasisCodePatternRow.order = row.order;
      fareBasisCodePatternRow.fbcValue = row.fbcValue;
      fareBasisCodePatternRow.fbcValueGroup = row.fbcValueGroup;
      fareBasisCodePatternProperties.push(fareBasisCodePatternRow);
    });
    return fareBasisCodePatternProperties;
  }
  function removeBlankValuesOfFareBrands(row) {
    _.forEach(row.rbdAssignmentProperties, function (rbdAssignmentProperty) {
      if (_.isEmpty(rbdAssignmentProperty.hostFareBrand)) {
        rbdAssignmentProperty.hostFareBrand = null;
      }
      _.forEach(rbdAssignmentProperty.rbdAssignmentCompFareClassList, function (rbdAssignmentCompFareClass) {
        if (_.isEmpty(rbdAssignmentCompFareClass.competitorFareBrand)) {
          rbdAssignmentCompFareClass.competitorFareBrand = null;
        }
      });
    });
  }
  function transformFORbdAssignmentPayload(row) {
    removeAdditionalKeys(row, ['linkWholeLadder', 'rbdMethod', 'ladderMethod', 'rbdAssignmentCompFareClassList']);
    removeBlankValuesOfFareBrands(row);
    return convertFOAttributeNameToAttributeName(row, 'rbdAssignmentProperties');
  }
  function transformFORbdAssignment(attrs, props, meta) {
    var propKey = _.chain(props).keys().head().value();
    var compFareClassList = [];
    var rbdMethod = props[propKey][0].rbdMethod;
    _.forEach(props[propKey], function (rbdAssignmentGroup) {
      compFareClassList = compFareClassList.concat(buildFORbdAssignmentCompFareClassList(rbdMethod, rbdAssignmentGroup, rbdAssignmentGroup.rbdAssignmentCompFareClassList));
    });
    var rbdAssignmentRow = {};
    rbdAssignmentRow = _.cloneDeep(attrs);
    if (_.isNil(attrs.hostCarrier) || _.isEmpty(attrs.hostCarrier)) {
      rbdAssignmentRow.hostCarrier = '';
    }
    rbdAssignmentRow.linkWholeLadder = props[propKey][0].linkWholeLadder;
    rbdAssignmentRow.rbdMethod = rbdMethod;
    rbdAssignmentRow.ladderMethod = props[propKey][0].ladderMethod;
    rbdAssignmentRow.rbdAssignmentCompFareClassList = compFareClassList;
    return transformAttributeNameToFOAttributeName(_.assign(rbdAssignmentRow, meta));
  }
  function buildFORbdAssignmentCompFareClassList(rbdMethod, rbdAssignmentGroup, rbdAssignmentCompFareClassProperties) {
    if (['ENTRY LEVEL RBD', 'RBD TO RBD', 'ORDINAL'].includes(rbdMethod)) {
      return buildFORbdAssignmentCompFareClassListForEntryLevelAndRbd(rbdAssignmentGroup, rbdAssignmentCompFareClassProperties);
    }
    var rbdAssignmentProperties = [];
    _.forEach(rbdAssignmentCompFareClassProperties, function (properties) {
      var rbdAssignmentRow = {};
      rbdAssignmentRow.competitorFareBrand = properties.competitorFareBrand;
      if (rbdMethod === 'FBC MAPPING') {
        rbdAssignmentRow.fbcMappingCompetitorAirline = properties.fbcMappingCompetitorAirline;
        rbdAssignmentRow.fbcMappingCompetitorFbc = properties.fbcMappingCompetitorFbc;
      } else if (rbdMethod === 'UPPER BOUND') {
        rbdAssignmentRow.upperBoundFbc = properties.upperBoundFbc;
        rbdAssignmentRow.upperBoundAmt = properties.upperBoundAmt;
        rbdAssignmentRow.typeIndicator = properties.typeIndicator;
      } else if (rbdMethod === 'VALUE BASED') {
        rbdAssignmentRow.minFare = properties.minFare;
        rbdAssignmentRow.maxFare = properties.maxFare;
        rbdAssignmentRow.currencyType = properties.currencyType;
      }
      rbdAssignmentRow.competitorFareSource = rbdAssignmentGroup.competitorFareSource;
      rbdAssignmentRow.fareTariffNumber = rbdAssignmentGroup.fareTariffNumber;
      rbdAssignmentRow.fareTypeIndicator = rbdAssignmentGroup.fareTypeIndicator;
      rbdAssignmentRow.hostSeason = rbdAssignmentGroup.hostSeason;
      rbdAssignmentRow.hostAP = rbdAssignmentGroup.hostAP;
      rbdAssignmentRow.useForLadderGeneration = rbdAssignmentGroup.useForLadderGeneration;
      rbdAssignmentRow.hostEntryLevelRbd = rbdAssignmentGroup.hostEntryLevelRbd;
      rbdAssignmentRow.hostFareBrand = rbdAssignmentGroup.hostFareBrand;
      rbdAssignmentProperties.push(rbdAssignmentRow);
    });
    return rbdAssignmentProperties;
  }
  function buildFORbdAssignmentCompFareClassListForEntryLevelAndRbd(rbdAssignmentGroup, rbdAssignmentCompFareClassProperties) {
    var rbdAssignmentProperties = [];
    var rbdsGroupedByProp = _.groupBy(rbdAssignmentCompFareClassProperties, 'competitorAirline');
    _.forEach(rbdsGroupedByProp, function (properties) {
      var rbdAssignmentRow = {};
      rbdAssignmentRow.competitorFareBrand = properties[0].competitorFareBrand;
      rbdAssignmentRow.competitorAirline = properties[0].competitorAirline;
      rbdAssignmentRow.competitorEntryLevelRbd = _.map(properties, 'competitorEntryLevelRbd').join(',');
      rbdAssignmentRow.competitorFareSource = rbdAssignmentGroup.competitorFareSource;
      rbdAssignmentRow.fareTariffNumber = rbdAssignmentGroup.fareTariffNumber;
      rbdAssignmentRow.fareTypeIndicator = rbdAssignmentGroup.fareTypeIndicator;
      rbdAssignmentRow.hostSeason = rbdAssignmentGroup.hostSeason;
      rbdAssignmentRow.hostAP = rbdAssignmentGroup.hostAP;
      rbdAssignmentRow.useForLadderGeneration = rbdAssignmentGroup.useForLadderGeneration;
      rbdAssignmentRow.hostEntryLevelRbd = rbdAssignmentGroup.hostEntryLevelRbd;
      rbdAssignmentRow.hostFareBrand = rbdAssignmentGroup.hostFareBrand;
      rbdAssignmentProperties.push(rbdAssignmentRow);
    });
    return rbdAssignmentProperties;
  }
  function transformFOTacticalUserOverridesPayload(row) {
    _.forEach(row.tariffLevelProperties, function (tariffLevelProperty) {
      if (_.isNil(tariffLevelProperty.cardinalityThreshold) && _.isNil(tariffLevelProperty.fareValidityThreshold) && _.isNil(tariffLevelProperty.cardinalityThresholdPercentageIndicator) && _.isEmpty(tariffLevelProperty.foTacticalFareBrandUserOverrideProperties[0].proactiveBlackoutPropertiesList)) {
        throw new Error('Atleast one property must be defined.');
      }
      var regExp = new RegExp('^(\\d{0,2}(\\.\\d{1,2}?)?|100(.00?)?)$');
      if (_.isEmpty(tariffLevelProperty.cardinalityThresholdPercentageIndicator)) {
        tariffLevelProperty.cardinalityThresholdPercentageIndicator = null;
      }
      if (!_.isNil(tariffLevelProperty.cardinalityThresholdPercentageIndicator)) {
        tariffLevelProperty.cardinalityThresholdPercentageIndicator = tariffLevelProperty.cardinalityThresholdPercentageIndicator === 'P';
      }
      if (!_.isNil(tariffLevelProperty.cardinalityThresholdPercentageIndicator) && !_.isNil(tariffLevelProperty.cardinalityThreshold)) {
        if (tariffLevelProperty.cardinalityThresholdPercentageIndicator && !tariffLevelProperty.cardinalityThreshold.toString().match(regExp)) {
          throw new Error('Cardinality Threshold Amount should be between 0 - 100 in case of percentage value');
        }
      }
      if (!_.isNil(tariffLevelProperty.foTacticalFareBrandUserOverrideProperties) && !_.isEmpty(tariffLevelProperty.foTacticalFareBrandUserOverrideProperties)) {
        _.forEach(tariffLevelProperty.foTacticalFareBrandUserOverrideProperties, function (foTacticalFareBrandUserOverrideProperty) {
          transformProactiveBlackoutsProperties(foTacticalFareBrandUserOverrideProperty);
        });
      }
    });
    delete row.fareTariffNumber;
    delete row.cardinalityThreshold;
    delete row.cardinalityThresholdPercentageIndicator;
    delete row.fareValidityThreshold;
    delete row.hostFareBrand;
    delete row.proactiveBlackoutPropertiesList;
    delete row.foSeasons;
    return convertFOAttributeNameToAttributeName(row);
  }
  function transformProactiveBlackoutsProperties(row) {
    var inboundProactiveBlackouts = [];
    var outboundProactiveBlackouts = [];
    _.forEach(row.proactiveBlackoutPropertiesList, function (proactiveBlackouts) {
      var proactiveBlackoutsProperties = {};
      proactiveBlackoutsProperties.begin = proactiveBlackouts['begin'].toISOString();
      proactiveBlackoutsProperties.end = proactiveBlackouts['end'].toISOString();
      if (proactiveBlackouts.inOrOutBoundType === 'IB') {
        inboundProactiveBlackouts.push(proactiveBlackoutsProperties);
      } else {
        outboundProactiveBlackouts.push(proactiveBlackoutsProperties);
      }
    });
    if (!_.isEmpty(inboundProactiveBlackouts)) {
      row.inboundProactiveBlackouts = inboundProactiveBlackouts;
    }
    if (!_.isEmpty(outboundProactiveBlackouts)) {
      row.outboundProactiveBlackouts = outboundProactiveBlackouts;
    }
    delete row.proactiveBlackoutPropertiesList;
  }
  function transformProactiveBlackoutsPropertiesToRender(properties, field) {
    var inOrOutBoundType = field === 'inboundProactiveBlackouts' ? 'IB' : 'OB';
    return _.map(properties, function (proactiveBlackoutProperties) {
      return {
        'inOrOutBoundType': inOrOutBoundType,
        'begin': momentService.of(proactiveBlackoutProperties.begin, momentService.FIELD.TRAVEL_DATE),
        'end': momentService.of(proactiveBlackoutProperties.end, momentService.FIELD.TRAVEL_DATE)
      };
    });
  }
  function transformFOBusinessRulesType(attrs, props, meta) {
    var propKey = _.chain(props).keys().head().value();
    var benchmarkRuleProperties = [];
    _.forEach(props[propKey], function (benchmarkRuleProperty) {
      _.forEach(benchmarkRuleProperty.benchmarkCarriers, function (benchmarkCarriers) {
        var benchmarkRulePropertyRow = {};
        benchmarkRulePropertyRow.season = benchmarkRuleProperty.season;
        benchmarkRulePropertyRow.normalizationIndicator = benchmarkCarriers.normalizationIndicator;
        benchmarkRulePropertyRow.benchmarkCarrier = benchmarkCarriers.benchmarkCarrier;
        benchmarkRulePropertyRow.fareTypeIndicator = benchmarkCarriers.fareTypeIndicator;
        benchmarkRulePropertyRow.mappedOwRt = benchmarkCarriers.mappedOwRt;
        benchmarkRulePropertyRow.fareSource = benchmarkCarriers.competitorFareSource;
        benchmarkRulePropertyRow.hostFareBrand = benchmarkCarriers.hostFareBrand;
        benchmarkRulePropertyRow.hostRbd = benchmarkCarriers.hostRbd;
        benchmarkRulePropertyRow.fareTariffNumber = benchmarkCarriers.fareTariffNumber;
        benchmarkRulePropertyRow.competitorFareBrand = benchmarkCarriers.competitorFareBrand;
        benchmarkRulePropertyRow.strategy = benchmarkCarriers.strategy;
        benchmarkRulePropertyRow.amount = benchmarkCarriers.amount;
        benchmarkRulePropertyRow.benchmarkFareComponent = benchmarkCarriers.benchmarkFareComponent;
        benchmarkRulePropertyRow.percentageIndicator = percentageIndicatorToString(benchmarkCarriers);
        benchmarkRulePropertyRow.origin = attrs.origin;
        benchmarkRulePropertyRow.destination = attrs.destination;
        benchmarkRulePropertyRow.cabin = attrs.cabin;
        benchmarkRulePropertyRow.category = attrs.category;
        benchmarkRulePropertyRow.recommendationMatchType = benchmarkRuleProperty.recommendationMatchType;
        attrs.recommendationMatchType = benchmarkRuleProperty.recommendationMatchType;
        benchmarkRuleProperties.push(benchmarkRulePropertyRow);
      });
    });
    props[propKey] = benchmarkRuleProperties;
    return transformAttributeNameToFOAttributeName(attrs, props, meta);
  }
  function percentageIndicatorToBoolean(property) {
    return property.percentageIndicator === 'P';
  }
  function percentageIndicatorToString(property) {
    return property.percentageIndicator === true ? 'P' : 'A';
  }
  function transformFOPosAnalystMapType(attrs, props, meta) {
    var propKey = _.chain(props).keys().head().value();
    var analystPosProperties = [];
    _.forEach(props[propKey], function (analystPosProperty) {
      var analystPosRow = {};
      analystPosRow.level = parseInt(analystPosProperty.level);
      analystPosRow.userName = buildCommaSeparatedUserNames(analystPosProperty.approversList);
      analystPosRow.pos = attrs.pos;
      analystPosProperties.push(analystPosRow);
    });
    props[propKey] = analystPosProperties;
    return transformAttributeNameToFOAttributeName(attrs, props, meta);
  }
  function buildCommaSeparatedUserNames(approversList) {
    return _.chain(approversList).map('userName').value().join(',');
  }
  function transformFOPosAnalystMapPayload(row) {
    var analystPosProperties = [];
    _.forEach(row.foAnalystPosMappingProperties, function (analystPosProperty) {
      var property = {};
      property.level = parseInt(analystPosProperty.level);
      property.approversList = buildApproversList(analystPosProperty.userName);
      analystPosProperties.push(property);
    });
    row.foAnalystPosMappingProperties = analystPosProperties;
    return row;
  }
  function buildApproversList(userNames) {
    var approvers = [];
    approvers.push({
      userName: userNames
    });
    return approvers;
  }
  function transformAttributeNameToFOAttributeName(attrs, props, meta) {
    if (!_.isNil(attrs) && !_.isNil(attrs.cabin)) {
      attrs.foCabin = attrs.cabin;
    }
    if (!_.isNil(attrs) && !_.isNil(attrs.carrier)) {
      attrs.foCarrier = attrs.carrier;
    }
    return _.assign(props, attrs, meta);
  }
  function transformFOUpSellBuyDownConfig(attrs, props, meta) {
    var upSellBuyDownRows = [];
    _.forEach(props.upSellBuyDownProperties, function (prop) {
      var upSellBuyDownRow = _.cloneDeep(attrs);
      upSellBuyDownRow.fareTariffNumber = prop.fareTariffNumber;
      upSellBuyDownRow.upSellAmount = prop.upSellAmount;
      upSellBuyDownRow.buyDownAmount = prop.buyDownAmount;
      if (!_.isNil(prop.upSellPercentageIndicator)) {
        upSellBuyDownRow.upSellPercentageIndicator = prop.upSellPercentageIndicator === true ? 'P' : 'A';
      }
      if (!_.isNil(prop.buyDownPercentageIndicator)) {
        upSellBuyDownRow.buyDownPercentageIndicator = prop.buyDownPercentageIndicator === true ? 'P' : 'A';
      }
      upSellBuyDownRows.push(transformAttributeNameToFOAttributeName(_.assign(upSellBuyDownRow, meta)));
    });
    return upSellBuyDownRows;
  }
  function validateFOUpSellBuyDownConfigPayloadBeforeSave(row) {
    var regExp = new RegExp('^(\\d{0,2}(\\.\\d{1,2}?)?|100(.00?)?)$');
    if (_.isNil(row.upSellPercentageIndicator) && _.isNil(row.buyDownPercentageIndicator) && _.isNil(row.buyDownAmount) && _.isNil(row.upSellAmount)) {
      throw new Error('Atleast one property should be non-empty.');
    }
    if (_.isNil(row.buyDownPercentageIndicator) && !_.isNil(row.buyDownAmount)) {
      throw new Error('BuyDown % Indicator should be non-empty.');
    }
    if (_.isNil(row.upSellPercentageIndicator) && !_.isNil(row.upSellAmount)) {
      throw new Error('UpSell % Indicator should be non-empty.');
    }
    if (!_.isNil(row.buyDownPercentageIndicator) && _.isNil(row.buyDownAmount)) {
      throw new Error('BuyDown Amount should be non-empty.');
    }
    if (!_.isNil(row.upSellPercentageIndicator) && _.isNil(row.upSellAmount)) {
      throw new Error('UpSell Amount should be non-empty.');
    }
    if (!_.isNil(row.upSellPercentageIndicator) && !_.isNil(row.upSellAmount)) {
      if (row.upSellPercentageIndicator && !row.upSellAmount.toString().match(regExp)) {
        throw new Error('UpSell Amount should be between 0 - 100 in case of percentage value');
      }
    }
    if (!_.isNil(row.buyDownPercentageIndicator) && !_.isNil(row.buyDownAmount)) {
      if (row.buyDownPercentageIndicator && !row.buyDownAmount.toString().match(regExp)) {
        throw new Error('Buydown Amount should be between 0 - 100 in case of percentage value');
      }
    }
  }
  function transformFOUpSellBuyDownConfigPayload(row) {
    _.forEach(row.upSellBuyDownProperties, function (property) {
      if (!_.isNil(property.upSellPercentageIndicator)) {
        property.upSellPercentageIndicator = property.upSellPercentageIndicator === 'P';
      }
      if (!_.isNil(property.buyDownPercentageIndicator)) {
        property.buyDownPercentageIndicator = property.buyDownPercentageIndicator === 'P';
      }
      if (!_.isNil(property.foCabin)) {
        property.cabin = property.foCabin;
        delete property.foCabin;
      }
      try {
        validateFOUpSellBuyDownConfigPayloadBeforeSave(property);
      } catch (e) {
        throw e;
      }
    });
    removeAdditionalKeys(row, ['fareTariffNumber', 'upSellAmount', 'upSellPercentageIndicator', 'buyDownAmount', 'buyDownPercentageIndicator']);
    convertFOAttributeNameToAttributeName(row, 'upSellBuyDownProperties');
    return row;
  }
  function transformFOCabinClassConfig(attrs, props, meta) {
    var propKey = 'cabinClassConfigPropertiesList';
    _.forEach(props[propKey], function (property) {
      property.foCabin = property.cabin;
    });
    return transformAttributeNameToFOAttributeName(attrs, props, meta);
  }
  function transformFOTaxOverride(attrs, props, meta) {
    var propKey = _.chain(props).keys().head().value();
    if (propKey === 'taxOverridePriority') {
      props.taxOverridePriority = props.taxOverridePriority.toUpperCase();
    } else {
      _.forEach(props[propKey], function (property) {
        property.fareType = property.fareType.toUpperCase();
        property.currencyCode = property.currencyCode.toUpperCase();
      });
    }
    return transformAttributeNameToFOAttributeName(attrs, props, meta);
  }
  function transformFOFareBrands(props, meta) {
    var propKey = _.chain(props).keys().head().value();
    var foFareBrands = [];
    _.forEach(props[propKey], function (foFareBrandProperty) {
      var foFareBrand = {};
      foFareBrand.carrier = foFareBrandProperty.carrier;
      foFareBrand.fareBrands = foFareBrandProperty.fareBrands;
      foFareBrands.push(_.assign(foFareBrand, meta));
    });
    return foFareBrands;
  }
  function transformFOMarketList(props, meta) {
    var propKey = _.chain(props).keys().head().value();
    var foMarketList = [];
    _.forEach(props[propKey], function (marketListProperty) {
      var foMarket = {};
      foMarket.hostCarrier = marketListProperty.hostCarrier;
      foMarket.fareTariffCode = marketListProperty.fareTariffCode;
      foMarket.fareTariffNumber = marketListProperty.fareTariffNumber;
      foMarket.originAirport = marketListProperty.origin;
      foMarket.destinationAirport = marketListProperty.destination;
      foMarket.foPos = marketListProperty.pos;
      foMarket.foCabin = marketListProperty.cabinCode;
      foMarket.benchmarkCarrier = marketListProperty.benchmarkCarrier.toString();
      foMarket.marketListCategory = marketListProperty.category;
      foMarket.marketTier = marketListProperty.marketTier;
      foMarket.fareChange = marketListProperty.fareChange;
      foMarket.adjustedTravelDates = marketListProperty.adjustedTravelDates;
      foMarket.generateNewCancel = marketListProperty.generateNewCancel;
      foMarket.approvedMarket = marketListProperty.approvedMarket;
      foMarket.checkEntryLevelFareChange = marketListProperty.checkEntryLevelFareChange;
      foMarket.approvedDaysOfWeek = marketListProperty.approvedDaysOfWeek;
      foMarket.exclusionReasons = marketListProperty.exclusionReasons;
      foMarket.hostFareTypeIndicator = marketListProperty.hostFareTypeIndicator;
      foMarket.benchmarkFareTypeIndicator = marketListProperty.benchmarkFareTypeIndicator;
      foMarket.fareSource = marketListProperty.fareSource;
      foMarket.minFareChangePercentage = marketListProperty.minFareChangePercentage;
      foMarket.maxFareChangePercentage = marketListProperty.maxFareChangePercentage;
      foMarketList.push(_.assign(foMarket, meta));
    });
    return foMarketList;
  }
  function transformFOTacticalFBCPatternConfig(attrs, props, meta) {
    var propKey = _.chain(props).keys().head().value();
    var foTacticalFBCPatternRows = [];
    var extractedSeasonDetails = configurationParametersAdvancedService.extractSeasonDetails();
    _.forEach(props[propKey], function (tacticalFbcPatternProperties) {
      var foTacticalFbcPatternRow = {};
      foTacticalFbcPatternRow = _.cloneDeep(attrs);
      foTacticalFbcPatternRow.propertyValue = tacticalFbcPatternProperties.propertyValue;
      if (!_.isNil(foTacticalFbcPatternRow.propertyName) && foTacticalFbcPatternRow.propertyName === 'Season') {
        foTacticalFbcPatternRow.propValue = extractedSeasonDetails.seasonsAbbreviationMap[foTacticalFbcPatternRow.propertyValue.toUpperCase()];
      } else {
        foTacticalFbcPatternRow.propValue = foTacticalFbcPatternRow.propertyValue;
      }
      if (!_.isNil(tacticalFbcPatternProperties.tacticalFbcPatterns)) {
        foTacticalFbcPatternRow.tacticalFbcPatterns = buildFBCPatternProperties(tacticalFbcPatternProperties.tacticalFbcPatterns);
      }
      foTacticalFbcPatternRow.seasonDefinitions = extractedSeasonDetails.seasonDefinitions;
      foTacticalFbcPatternRow.seasons = extractedSeasonDetails.seasons;
      foTacticalFBCPatternRows.push(transformAttributeNameToFOAttributeName(_.assign(foTacticalFbcPatternRow, meta)));
    });
    return foTacticalFBCPatternRows;
  }
  function buildFBCPatternProperties(tacticalFBCPattern) {
    var fbcPatternProperties = [];
    _.forEach(tacticalFBCPattern, function (fbcPattern) {
      var foTacticalFBCPatternRow = {};
      foTacticalFBCPatternRow.fareSource = fbcPattern.competitorFareSource;
      foTacticalFBCPatternRow.position = fbcPattern.position;
      foTacticalFBCPatternRow.include = fbcPattern.include;
      foTacticalFBCPatternRow.exclude = fbcPattern.exclude;
      foTacticalFBCPatternRow.modifierFBC = fbcPattern.modifierFBC;
      fbcPatternProperties.push(foTacticalFBCPatternRow);
    });
    return fbcPatternProperties;
  }
  function transformFOTacticalFBCPatternConfigPayload(row) {
    var tacticalFBCPatternPropertyRow = [];
    var seasons = row.seasonDefinitions;
    _.forEach(row.tacticalFbcPatternProperties, function (eachTacticalFbcPatternProperty) {
      var propertyValue = eachTacticalFbcPatternProperty.propertyValue || row.propValue || '';
      if (row.propertyName === 'fareBrand') {
        propertyValue = propertyValue.toUpperCase();
      } else if (row.propertyName === 'Season') {
        propertyValue = _.find(seasons, {
          'season': propertyValue
        }).seasonAbbreviation;
      }
      var tacticalFbcPatternProperties = {};
      var tacticalFbcPatterns = [];
      _.forEach(eachTacticalFbcPatternProperty.tacticalFbcPatterns, function (eachTacticalFbcPattern) {
        var tacticalFbcPattern = {};
        if (!_.isNil(eachTacticalFbcPattern.fareSource)) {
          tacticalFbcPattern.competitorFareSource = eachTacticalFbcPattern.fareSource;
        }
        if (!_.isNil(eachTacticalFbcPattern.position)) {
          tacticalFbcPattern.position = eachTacticalFbcPattern.position;
        }
        if (!_.isNil(eachTacticalFbcPattern.include)) {
          tacticalFbcPattern.include = eachTacticalFbcPattern.include;
        }
        if (!_.isNil(eachTacticalFbcPattern.exclude)) {
          tacticalFbcPattern.exclude = eachTacticalFbcPattern.exclude;
        }
        tacticalFbcPattern.modifierFBC = eachTacticalFbcPattern.modifierFBC;
        tacticalFbcPatterns.push(tacticalFbcPattern);
      });
      tacticalFbcPatternProperties.propertyValue = propertyValue;
      tacticalFbcPatternProperties.tacticalFbcPatterns = tacticalFbcPatterns;
      tacticalFBCPatternPropertyRow.push(tacticalFbcPatternProperties);
    });
    row.tacticalFbcPatternProperties = tacticalFBCPatternPropertyRow;
    removeAdditionalKeys(row, ['seasonDefinitions', 'seasons', 'seasonsAbbreviationMap', 'propValue', 'propertyValue', 'tacticalFbcPatterns']);
    return convertFOAttributeNameToAttributeName(row, 'tacticalFbcPatternProperties');
  }
  function removeAdditionalKeys(row, keys) {
    for (var i = 0; i < keys.length; i++) {
      delete row[keys[i]];
    }
  }
  function transformFORbdLevelFareThreshold(attrs, props, meta) {
    if (!_.isNil(props.override)) {
      props.override = props.override.toString().toUpperCase();
    }
    if (!_.isNil(props.foRBDLevelFareThresholdPropertiesList)) {
      buildRbdLevelThresholdProperties(props, attrs, meta);
    }
    return transformAttributeNameToFOAttributeName(attrs, props, meta);
  }
  function buildRbdLevelThresholdProperties(props, attrs, meta) {
    var rbdLevelFareThresholdProperties = [];
    _.forEach(props.foRBDLevelFareThresholdPropertiesList, function (property) {
      var rbdLevelFareThresholdPropertyRow = {};
      rbdLevelFareThresholdPropertyRow.fareTypeIndicator = property.fareTypeIndicator;
      rbdLevelFareThresholdPropertyRow.fareTariffNumber = property.fareTariffNumber;
      rbdLevelFareThresholdPropertyRow.foRbd = property.rbd;
      if (!_.isNil(property.minFareThreshold)) {
        rbdLevelFareThresholdPropertyRow.minFareThreshold = property.minFareThreshold;
      }
      if (!_.isNil(property.maxFareThreshold)) {
        rbdLevelFareThresholdPropertyRow.maxFareThreshold = property.maxFareThreshold;
      }
      if (!_.isNil(property.minFareThresholdPercent)) {
        rbdLevelFareThresholdPropertyRow.minFareThresholdPercent = property.minFareThresholdPercent;
      }
      if (!_.isNil(property.maxFareThresholdPercent)) {
        rbdLevelFareThresholdPropertyRow.maxFareThresholdPercent = property.maxFareThresholdPercent;
      }
      if (!_.isNil(attrs.origin)) {
        rbdLevelFareThresholdPropertyRow.origin = attrs.origin;
        rbdLevelFareThresholdPropertyRow.destination = attrs.destination;
      } else if (!_.isNil(attrs.pos)) {
        rbdLevelFareThresholdPropertyRow.pos = attrs.pos;
      }
      rbdLevelFareThresholdProperties.push(rbdLevelFareThresholdPropertyRow);
    });
    props.foRBDLevelFareThresholdPropertiesList = rbdLevelFareThresholdProperties;
    return transformAttributeNameToFOAttributeName(attrs, props, meta);
  }
  function transformFOFareClassMapping(attrs, props, meta) {
    var propKey = _.chain(props).keys().head().value();
    var fareClassMappingProperties = [];
    _.forEach(props[propKey], function (fareClassMapping) {
      var rbdsGroupedByCarrier = _.groupBy(fareClassMapping.competitorFareClassMappingList, 'competitorAirline');
      _.forEach(rbdsGroupedByCarrier, function (rbdGroupedByCarrier) {
        var foFareClassMapping = {};
        foFareClassMapping.fareSource = fareClassMapping.competitorFareSource;
        foFareClassMapping.fareTariffNumber = fareClassMapping.fareTariffNumber;
        foFareClassMapping.fareTypeIndicator = fareClassMapping.fareTypeIndicator;
        foFareClassMapping.inventoryAssignmentMethod = fareClassMapping.inventoryAssignmentMethod;
        foFareClassMapping.ladderGenerationMethod = fareClassMapping.ladderGenerationMethod;
        foFareClassMapping.useForLadderGeneration = fareClassMapping.useForLadderGeneration;
        foFareClassMapping.hostEntryLevelRBD = fareClassMapping.hostEntryLevelRBD;
        foFareClassMapping.competitorAirline = rbdGroupedByCarrier[0].competitorAirline;
        if (!_.isNil(fareClassMapping.hostFareBrand)) {
          foFareClassMapping.hostFareBrand = fareClassMapping.hostFareBrand;
        }
        if (!_.isNil(rbdGroupedByCarrier[0].competitorFareBrand)) {
          foFareClassMapping.competitorFareBrand = rbdGroupedByCarrier[0].competitorFareBrand;
        }
        foFareClassMapping.competitorEntryLevelRbds = _.map(rbdGroupedByCarrier, 'competitorEntryLevelRBD').join(',');
        foFareClassMapping.origin = attrs.origin;
        foFareClassMapping.destination = attrs.destination;
        foFareClassMapping.cabin = attrs.cabin;
        foFareClassMapping.category = attrs.category;
        fareClassMappingProperties.push(foFareClassMapping);
      });
    });
    props[propKey] = fareClassMappingProperties;
    return transformAttributeNameToFOAttributeName(attrs, props, meta);
  }
  function getBenchmarkCarrierUpdatePayload(marketConfigRow, cabin) {
    return {
      type: 'FP_BenchmarkCarriers',
      hepKey: ['FP_BenchmarkCarriers', HOST_CARRIER, marketConfigRow.marketOrigin, marketConfigRow.marketDestination, cabin].join('.'),
      attributes: {
        marketDestination: marketConfigRow.marketDestination,
        marketOrigin: marketConfigRow.marketOrigin,
        cabinCode: cabin,
        carrier: HOST_CARRIER
      },
      properties: {
        benchmarkCarriers: marketConfigRow[getBenchmarkFieldName(cabin)]
      }
    };
  }
  function getBenchmarkCarrierDeletePayload(marketConfigRow, cabin) {
    return {
      type: 'FP_BenchmarkCarriers',
      hepKey: ['FP_BenchmarkCarriers', HOST_CARRIER, marketConfigRow.marketOrigin, marketConfigRow.marketDestination, cabin].join('.')
    };
  }
  function getMarketConfigRow(row, isExport) {
    var availableCabins = configurationService.getCabins();
    var benchmarkCarrierProperties = _.map(availableCabins, function (cabin) {
      return BENCHMARK_CARRIER_FIELD_PREFIX + cabin;
    });
    var shouldParseBoolean = function shouldParseBoolean(fieldName) {
      return fieldName !== 'isDynamicPricingAdj' && fieldName !== 'isMlModelEnabled' && fieldName !== 'isFareBrandEnabled' || fieldName === 'isDynamicPricingAdj' && featureToggleService.isEnabled('DYNAMIC_PRICING') || fieldName === 'isMlModelEnabled' && featureToggleService.isEnabled('DYNAMIC_AVAILABILITY_ML_MODEL') || fieldName === 'isFareBrandEnabled' && featureToggleService.isEnabled('DYNAMIC_AVAILABILITY_FARE_BRAND');
    };
    var marketConfigRow = _.omit(row, benchmarkCarrierProperties);
    if (_.isNil(marketConfigRow['marketConfigParams_maxClassClosures'])) {
      marketConfigRow['marketConfigParams_maxClassClosures'] = 2;
    }
    if (_.isNil(marketConfigRow['marketConfigParams_isShiftShopping'])) {
      marketConfigRow['marketConfigParams_isShiftShopping'] = false;
    }
    if (!_.isNil(marketConfigRow['marketConfigParams_riaMethod']) && !isExport) {
      marketConfigRow['marketConfigParams_riaMethod'] = _.invert(RIA_METHOD_MAP)[marketConfigRow['marketConfigParams_riaMethod']];
    }
    if (!_.isNil(marketConfigRow['marketConfigParams_source']) && !isExport) {
      marketConfigRow['marketConfigParams_source'] = _.invert(MARKET_CONFIG_SOURCE_METHOD_MAP)[marketConfigRow['marketConfigParams_source']];
    }
    _.forEach(OPERATOR_NUMBER_PROPS, function (value, fieldName) {
      fpMarketConfigParsingService.mergeParsedNumber(marketConfigRow, 'marketConfigParams_' + fieldName);
    });
    _.forEach(marketConfigRow['marketConfigParams_blackoutDeptDateParams'], function (dateRow) {
      fpMarketConfigParsingService.mergeParsedDate(dateRow, 'start');
      fpMarketConfigParsingService.mergeParsedDate(dateRow, 'end');
    });
    _.forEach(marketConfigRow['marketConfigParams_dtdBlackout'], function (dateRow) {
      fpMarketConfigParsingService.mergeParsedNumber(dateRow, 'dtdCondition');
    });
    _.forEach(OPERATOR_BOOLEAN_PROPS, function (value, fieldName) {
      if (shouldParseBoolean(fieldName)) {
        fpMarketConfigParsingService.parseBoolean(marketConfigRow, 'marketConfigParams_' + fieldName);
      }
    });
    if (!marketConfigRow['marketConfigParams_isDynamicPricingAdj']) {
      delete marketConfigRow['marketConfigParams_dynamicPricingAdjLOSRanges'];
    }
    if (featureToggleService.isEnabled('DYNAMIC_PRICING') && marketConfigRow['marketConfigParams_isDynamicPricingAdj'] && _.isEmpty(marketConfigRow['marketConfigParams_dynamicPricingAdjLOSRanges'])) {
      marketConfigRow['marketConfigParams_dynamicPricingAdjLOSRanges'] = [{
        losStart: 0,
        losEnd: 330
      }];
    }
    if (!marketConfigRow['marketConfigParams_isMlModelEnabled']) {
      delete marketConfigRow['marketConfigParams_mlParams'];
    }
    if (!featureToggleService.isEnabled('DYNAMIC_AVAILABILITY_ML_MODEL')) {
      delete marketConfigRow['marketConfigParams_mlParams'];
      delete marketConfigRow['marketConfigParams_isMlModelEnabled'];
    }
    if (!featureToggleService.isEnabled('DYNAMIC_AVAILABILITY_FARE_BRAND')) {
      delete marketConfigRow['marketConfigParams_isFareBrandEnabled'];
    }
    return marketConfigRow;
  }
  function getBenchmarkCarriersForUpdate(row) {
    var availableCabins = configurationService.getCabins();
    return _.transform(availableCabins, function (result, cabin) {
      if (row[getBenchmarkFieldName(cabin)]) {
        result.push(getBenchmarkCarrierUpdatePayload(row, cabin));
      }
      return result;
    });
  }
  function getBenchmarkCarriersForDelete(row, editedOnly) {
    var availableCabins = configurationService.getCabins();
    return _.transform(availableCabins, function (result, cabin) {
      var isDeletedFromRow = row[getBenchmarkFieldName(cabin)] === '' && row._old[getBenchmarkFieldName(cabin)];
      var isPresentInRow = row[getBenchmarkFieldName(cabin)];
      if (editedOnly ? isDeletedFromRow : isPresentInRow) {
        result.push(getBenchmarkCarrierDeletePayload(row, cabin));
      }
      return result;
    });
  }
  function addConnectionTimeOperators(row) {
    if (_.isNil(row['marketConfigParams_maxConnectionTime_value'])) {
      delete row['marketConfigParams_maxConnectionTime_operator'];
    } else {
      row['marketConfigParams_maxConnectionTime_operator'] = '>';
    }
    if (_.isNil(row['marketConfigParams_minConnectionTime_value'])) {
      delete row['marketConfigParams_minConnectionTime_operator'];
    } else {
      if (parseInt(row['marketConfigParams_minConnectionTime_value'], 10) === 0) {
        row['marketConfigParams_minConnectionTime_operator'] = '=';
      } else {
        row['marketConfigParams_minConnectionTime_operator'] = '<';
      }
    }
    return row;
  }
  function transformFpMarketConfigPayload(row, isExport) {
    row = addConnectionTimeOperators(row);
    var marketConfigRow = getMarketConfigRow(row, isExport);
    var modifyBenchmarkCarriers = getBenchmarkCarriersForUpdate(row);
    var deleteBenchmarkCarriers = getBenchmarkCarriersForDelete(row, true);
    return {
      marketConfigRow: marketConfigRow,
      modifyBenchmarkCarriers: modifyBenchmarkCarriers.length ? modifyBenchmarkCarriers : [],
      deleteBenchmarkCarriers: deleteBenchmarkCarriers.length ? deleteBenchmarkCarriers : []
    };
  }
  function transformFpTodHubBankConfigPayload(row) {
    var todTimeBands = row['todHubBankParams_todTimeBands'];
    row['todHubBankParams_todTimeBands'] = _.sortBy(todTimeBands, 'timeBandSequence');
    return row;
  }
  function transformFpMetroMarketPayload(row) {
    if (_.isNil(row['metroMarketParams_neighbors']) || _.isEmpty(row['metroMarketParams_neighbors'])) {
      throw new Error('Neighboring Markets should be specified in parameters.');
    }
    if (_.isNil(row['carrier'])) {
      row['carrier'] = HOST_CARRIER;
    }
    return row;
  }
  function transformCurtainRulePayload(row) {
    var availableCabins = configurationService.getCabins();
    _.forEach(row['curtainRuleParam_cabinOptions'], function (cabinOptionsRow) {
      cabinOptionsRow[CABIN_CAPACITIES_FIELD_PREFIX] = {};
      _.forEach(availableCabins, function (cabinName) {
        var fieldName = getCabinCapacitiesFieldName(cabinName);
        if (!_.isNil(cabinOptionsRow[fieldName])) {
          cabinOptionsRow[CABIN_CAPACITIES_FIELD_PREFIX][cabinName] = cabinOptionsRow[fieldName];
        }
        delete cabinOptionsRow[fieldName];
      });
    });
    calculateSeatFactorForRow(row);
    return row;
  }
  function convertFOAttributeNameToAttributeName(row, property) {
    if (!_.isNil(row.foCabin)) {
      row.cabin = row.foCabin;
      delete row.foCabin;
    }
    if (!_.isNil(row.foCarrier)) {
      row.carrier = row.foCarrier;
      delete row.foCarrier;
    }
    if (!_.isNil(row.adaptivePricingCategory)) {
      row.category = row.adaptivePricingCategory;
      delete row.adaptivePricingCategory;
    }
    if (property !== undefined && row[property] === undefined) {
      row[property] = [];
    }
    return row;
  }
  function transformFOBusinessRulesPayload(row) {
    var templateBusinessRuleProperty = {
      'season': '',
      'benchmarkCarriers': [],
      'recommendationMatchType': ''
    };
    var businessRulesProperties = [];
    var foCategoryCabinRbdsMapping = configurationService.getRbdsByCarrierCategoryCabin();
    var categoryCabinRbdKey = row.hostCarrier;
    _.forEach(row.businessRulesProperties, function (businessRulesProperty) {
      var inputRbds = businessRulesProperty.hostRbd ? businessRulesProperty.hostRbd.split(',') : [''];
      var possibleRbds = configurationService.getFoCategoryCabinRbds(row, foCategoryCabinRbdsMapping, categoryCabinRbdKey);
      possibleRbds = _.isEqual(possibleRbds, ['']) ? possibleRbds : _.concat([''], possibleRbds);
      var validRbds = _.intersection(inputRbds, possibleRbds);
      if (inputRbds.length !== 0 && validRbds.length !== inputRbds.length) {
        throw new Error([row.origin, row.destination, row.foCabin, row.category].join('.') + ' - found invalid RBDs');
      }
      var businessRuleProp = _.find(businessRulesProperties, {
        'season': businessRulesProperty.season
      });
      var benchmarkCarrier = {};
      benchmarkCarrier.normalizationIndicator = _.isNil(businessRulesProperty.normalizationIndicator) ? false : businessRulesProperty.normalizationIndicator;
      benchmarkCarrier.benchmarkCarrier = businessRulesProperty.benchmarkCarrier;
      benchmarkCarrier.fareTypeIndicator = businessRulesProperty.fareTypeIndicator;
      benchmarkCarrier.mappedOwRt = businessRulesProperty.mappedOwRt;
      benchmarkCarrier.competitorFareSource = businessRulesProperty.fareSource;
      benchmarkCarrier.hostFareBrand = businessRulesProperty.hostFareBrand;
      benchmarkCarrier.hostRbd = businessRulesProperty.hostRbd;
      benchmarkCarrier.fareTariffNumber = businessRulesProperty.fareTariffNumber;
      benchmarkCarrier.competitorFareBrand = businessRulesProperty.competitorFareBrand;
      benchmarkCarrier.strategy = businessRulesProperty.strategy;
      benchmarkCarrier.amount = businessRulesProperty.amount;
      benchmarkCarrier.benchmarkFareComponent = businessRulesProperty.benchmarkFareComponent;
      benchmarkCarrier.percentageIndicator = businessRulesProperty.percentageIndicator === 'P';
      if (!businessRuleProp) {
        businessRuleProp = _.cloneDeep(templateBusinessRuleProperty);
        businessRuleProp.season = businessRulesProperty.season;
      }
      businessRuleProp.benchmarkCarriers.push(benchmarkCarrier);
      businessRuleProp.recommendationMatchType = row.recommendationMatchType;
      if (!_.find(businessRulesProperties, {
        'season': businessRulesProperty.season
      })) {
        businessRulesProperties.push(businessRuleProp);
      }
    });
    row.businessRulesProperties = businessRulesProperties;
    removeAdditionalKeys(row, ['recommendationMatchType']);
    return convertFOAttributeNameToAttributeName(row, 'businessRulesProperties');
  }
  function transformFOCabinClassConfigPayload(row, property) {
    if (row[property] === undefined) {
      row[property] = [];
    }
    _.forEach(row.cabinClassConfigPropertiesList, function (property) {
      property.cabin = property.foCabin.toUpperCase();
      property.className = property.className.toUpperCase();
      if (property.fareBrand) {
        property.fareBrand = property.fareBrand.toUpperCase();
      }
      delete property.foCabin;
    });
    return convertFOAttributeNameToAttributeName(row, 'cabinClassConfigPropertiesList');
  }
  function transformFOAdvancePurchaseGrouping(attrs, props, meta) {
    if (!_.isNil(props.advancePurchaseGroupingProperty.ladderGenerationAPCheck)) {
      props.ladderGenerationAPCheck = props.advancePurchaseGroupingProperty.ladderGenerationAPCheck.toString().toUpperCase();
    }
    if (!_.isNil(props.advancePurchaseGroupingProperty.advancePurchaseGroupingProperties)) {
      var advancePurchaseGroupingProperties = [];
      _.forEach(props.advancePurchaseGroupingProperty.advancePurchaseGroupingProperties, function (property) {
        var advancePurchaseGroupingPropertyRow = {};
        advancePurchaseGroupingPropertyRow.fareTypeIndicator = property.fareTypeIndicator;
        advancePurchaseGroupingPropertyRow.advancePurchaseStart = property.advancePurchaseStart;
        advancePurchaseGroupingPropertyRow.advancePurchaseEnd = property.advancePurchaseEnd;
        if (!_.isNil(property.predefinedAP)) {
          advancePurchaseGroupingPropertyRow.predefinedAP = property.predefinedAP;
        }
        advancePurchaseGroupingProperties.push(advancePurchaseGroupingPropertyRow);
      });
    }
    props.advancePurchaseGroupingProperties = advancePurchaseGroupingProperties;
    delete props.advancePurchaseGroupingProperty;
    return transformAttributeNameToFOAttributeName(attrs, props, meta);
  }
  function transformFOAdvancePurchaseGroupingPayload(row) {
    var advancePurchaseGroupingProperty = {};
    if (!_.isNil(row.ladderGenerationAPCheck)) {
      row.ladderGenerationAPCheck = row.ladderGenerationAPCheck === 'TRUE' || row.ladderGenerationAPCheck === 'FALSE' ? JSON.parse(row.ladderGenerationAPCheck.toLowerCase()) : undefined;
      advancePurchaseGroupingProperty.ladderGenerationAPCheck = row.ladderGenerationAPCheck;
    }
    var advancePurchaseGroupingProperties = [];
    _.forEach(row.advancePurchaseGroupingProperties, function (property) {
      var advancePurchaseGroupingPropertyRow = {};
      advancePurchaseGroupingPropertyRow.advancePurchaseStart = property.advancePurchaseStart;
      advancePurchaseGroupingPropertyRow.advancePurchaseEnd = property.advancePurchaseEnd;
      advancePurchaseGroupingPropertyRow.fareTypeIndicator = property.fareTypeIndicator;
      if (!_.isNil(property.predefinedAP)) advancePurchaseGroupingPropertyRow.predefinedAP = property.predefinedAP;
      advancePurchaseGroupingProperties.push(advancePurchaseGroupingPropertyRow);
    });
    delete row.ladderGenerationAPCheck;
    delete row.advancePurchaseGroupingProperties;
    advancePurchaseGroupingProperty.advancePurchaseGroupingProperties = advancePurchaseGroupingProperties;
    row.advancePurchaseGroupingProperty = advancePurchaseGroupingProperty;
    return convertFOAttributeNameToAttributeName(row, 'advancePurchaseGroupingProperty');
  }
  function transformFONoticePeriodType(attrs, props, meta) {
    if (!_.isNil(attrs === null || attrs === void 0 ? void 0 : attrs.category)) {
      attrs.adaptivePricingCategory = attrs.category;
    }
    _.forEach(props.noticePeriodProperties, function (noticePeriodProperty) {
      if (!_.isNil(noticePeriodProperty.userIds)) {
        noticePeriodProperty.userName = noticePeriodProperty.userIds;
        delete noticePeriodProperty.userIds;
      }
    });
    return transformAttributeNameToFOAttributeName(attrs, props, meta);
  }
  function transformFONoticePeriodPayload(row) {
    var noticePeriodProperties = [];
    _.forEach(row.noticePeriodProperties, function (noticePeriodProperty) {
      var noticePeriodPropertyRow = {};
      if (!_.isNil(noticePeriodProperty.fareChangeDirection)) {
        noticePeriodPropertyRow.fareChangeDirection = noticePeriodProperty.fareChangeDirection;
      }
      noticePeriodPropertyRow.fareTariffNumber = noticePeriodProperty.fareTariffNumber;
      if (!_.isNil(noticePeriodProperty.excludedDaysOfWeek)) {
        noticePeriodPropertyRow.excludedDaysOfWeek = noticePeriodProperty.excludedDaysOfWeek;
      }
      if (!_.isNil(noticePeriodProperty.userName)) {
        noticePeriodPropertyRow.userIds = noticePeriodProperty.userName;
      }
      noticePeriodPropertyRow.noticePeriod = noticePeriodProperty.noticePeriod;
      noticePeriodProperties.push(noticePeriodPropertyRow);
    });
    row.noticePeriodProperties = noticePeriodProperties;
    return convertFOAttributeNameToAttributeName(row, 'noticePeriodProperties');
  }
  function transformFOViaPoints(attrs, props, meta) {
    return transformAttributeNameToFOAttributeName(attrs, props, meta);
  }
  function transformFOViaPointsPayload(row) {
    var viaPointsProperties = [];
    _.forEach(row.viaPointsProperties, function (viaPointsProperty) {
      var viaPointsPropertyRow = {};
      viaPointsPropertyRow.routingNumber = viaPointsProperty.routingNumber;
      if (!_.isNil(viaPointsProperty.connectionOutbound)) {
        viaPointsPropertyRow.connectionOutbound = viaPointsProperty.connectionOutbound;
      }
      if (!_.isNil(viaPointsProperty.carrierOutbound)) {
        viaPointsPropertyRow.carrierOutbound = viaPointsProperty.carrierOutbound;
      }
      if (!_.isNil(viaPointsProperty.connectionInbound)) {
        viaPointsPropertyRow.connectionInbound = viaPointsProperty.connectionInbound;
      }
      if (!_.isNil(viaPointsProperty.carrierInbound)) {
        viaPointsPropertyRow.carrierInbound = viaPointsProperty.carrierInbound;
      }
      if (!_.isNil(viaPointsProperty.gds)) {
        viaPointsPropertyRow.gds = viaPointsProperty.gds;
      }
      viaPointsProperties.push(viaPointsPropertyRow);
    });
    row.viaPointsProperties = viaPointsProperties;
    return convertFOAttributeNameToAttributeName(row, 'viaPointsProperties');
  }
  function transformFOTotalFareCityAirportConversion(attrs, props, meta) {
    return transformAttributeNameToFOAttributeName(attrs, props, meta);
  }
  function transformFOTotalFareCityAirportConversionPayload(row) {
    if (!_.isNil(row.city)) {
      row.city = row.city.toUpperCase();
    }
    if (!_.isNil(row.airport)) {
      row.airport = row.airport.toUpperCase();
    }
    if (!_.isNil(row.foCarrier)) {
      row.carrier = row.foCarrier;
      delete row.foCarrier;
    }
    try {
      validateFOTotalFareCityAirportConversionPayloadBeforeSave(row);
    } catch (e) {
      throw e;
    }
    return row;
  }
  function validateFOTotalFareCityAirportConversionPayloadBeforeSave(row) {
    if (_.isNil(row.city)) {
      throw new Error('City should be non-empty.');
    }
    if (_.isNil(row.airport)) {
      throw new Error('Airport should be non-empty.');
    }
  }
  function transformFORbdLevelFareThresholdPayload(row) {
    if (!_.isNil(row.override)) {
      row.override = row.override === 'TRUE' || row.override === 'FALSE' ? JSON.parse(row.override.toLowerCase()) : undefined;
    }
    if (!_.isNil(row.foRBDLevelFareThresholdPropertiesList)) {
      transformRbdLevelThresholdProperties(row);
    }
    return convertFOAttributeNameToAttributeName(row);
  }
  function transformRbdLevelThresholdProperties(row) {
    var rbdLevelFareThresholdProperties = [];
    _.forEach(row.foRBDLevelFareThresholdPropertiesList, function (rbdLevelFareThresholdProperty) {
      var rbdLevelFareThresholdPropertyRow = {};
      rbdLevelFareThresholdPropertyRow.fareTypeIndicator = rbdLevelFareThresholdProperty.fareTypeIndicator;
      rbdLevelFareThresholdPropertyRow.fareTariffNumber = rbdLevelFareThresholdProperty.fareTariffNumber;
      rbdLevelFareThresholdPropertyRow.rbd = rbdLevelFareThresholdProperty.foRbd;
      if (!_.isNil(rbdLevelFareThresholdProperty.minFareThreshold)) {
        rbdLevelFareThresholdPropertyRow.minFareThreshold = rbdLevelFareThresholdProperty.minFareThreshold;
      }
      if (!_.isNil(rbdLevelFareThresholdProperty.maxFareThreshold)) {
        rbdLevelFareThresholdPropertyRow.maxFareThreshold = rbdLevelFareThresholdProperty.maxFareThreshold;
      }
      if (!_.isNil(rbdLevelFareThresholdProperty.minFareThresholdPercent)) {
        rbdLevelFareThresholdPropertyRow.minFareThresholdPercent = rbdLevelFareThresholdProperty.minFareThresholdPercent;
      }
      if (!_.isNil(rbdLevelFareThresholdProperty.maxFareThresholdPercent)) {
        rbdLevelFareThresholdPropertyRow.maxFareThresholdPercent = rbdLevelFareThresholdProperty.maxFareThresholdPercent;
      }
      rbdLevelFareThresholdProperties.push(rbdLevelFareThresholdPropertyRow);
    });
    row.foRBDLevelFareThresholdPropertiesList = rbdLevelFareThresholdProperties;
    return convertFOAttributeNameToAttributeName(row, 'foRBDLevelFareThresholdPropertiesList');
  }
  function transformFOInputDataComparisonChecksType(attrs, props, meta) {
    var propKey = _.chain(props).keys().head().value();
    var inputDataComparisonChecksProperties = [];
    _.forEach(props[propKey], function (inputDataComparisonChecks) {
      _.forEach(inputDataComparisonChecks.inputSourceSpecificProperties, function (property) {
        var foInputDataComparisonChecks = {};
        foInputDataComparisonChecks.inputSource = inputDataComparisonChecks.inputSource;
        foInputDataComparisonChecks.fareTariffNumber = inputDataComparisonChecks.fareTariffNumber;
        if (!_.isNil(property.inputType)) {
          foInputDataComparisonChecks.inputType = property.inputType;
        }
        if (!_.isNil(property.absoluteChange)) {
          foInputDataComparisonChecks.absoluteChange = property.absoluteChange;
        }
        if (!_.isNil(property.percentageChange)) {
          foInputDataComparisonChecks.percentageChange = property.percentageChange;
        }
        inputDataComparisonChecksProperties.push(foInputDataComparisonChecks);
      });
    });
    props[propKey] = inputDataComparisonChecksProperties;
    return transformAttributeNameToFOAttributeName(attrs, props, meta);
  }
  function transformFOInputDataComparisonChecksPayload(row) {
    var inputDataComparisonChecks = [];
    var groupingByInputSourceFareTariffNumber = _.groupBy(row.inputDataComparisonChecksProperties, function (prop) {
      return prop.inputSource + prop.fareTariffNumber;
    });
    _.forEach(groupingByInputSourceFareTariffNumber, function (entry) {
      var propertyRow = {};
      propertyRow.inputSource = entry[0].inputSource;
      propertyRow.fareTariffNumber = entry[0].fareTariffNumber;
      propertyRow.inputSourceSpecificProperties = getInputSourceSpecificProperties(groupingByInputSourceFareTariffNumber[entry[0].inputSource + entry[0].fareTariffNumber]);
      inputDataComparisonChecks.push(propertyRow);
    });
    row.inputDataComparisonChecksProperties = inputDataComparisonChecks;
    return convertFOAttributeNameToAttributeName(row, 'inputDataComparisonChecksProperties');
  }
  function getInputSourceSpecificProperties(propertiesGroupedByInputSource) {
    var inputSourceSpecificProperties = [];
    _.forEach(propertiesGroupedByInputSource, function (property) {
      var inputSourceSpecificPropertyRow = {};
      inputSourceSpecificPropertyRow.inputType = property.inputType;
      inputSourceSpecificPropertyRow.absoluteChange = property.absoluteChange;
      inputSourceSpecificPropertyRow.percentageChange = property.percentageChange;
      inputSourceSpecificProperties.push(inputSourceSpecificPropertyRow);
    });
    return inputSourceSpecificProperties;
  }
  function transformFOFareClassMappingPayLoad(row) {
    var fareClassMappingProperties = [];
    var groupingByCompFareSource = _.groupBy(row.fareClassMappingProperties, 'fareSource');
    _.forEach(_.keys(groupingByCompFareSource), function (cpmFareSource) {
      var groupingByFareTypeIndicator = _.groupBy(groupingByCompFareSource[cpmFareSource], 'fareTypeIndicator');
      _.forEach(_.keys(groupingByFareTypeIndicator), function (fareTypeIndicator) {
        var groupingByEntryLevelRbd = _.groupBy(groupingByFareTypeIndicator[fareTypeIndicator], 'hostEntryLevelRBD');
        _.forEach(groupingByEntryLevelRbd, function (hostEntries) {
          var groupingByHostFareBrand = _.groupBy(hostEntries, 'hostFareBrand');
          _.forEach(groupingByHostFareBrand, function (entry) {
            var propertyRow = {};
            propertyRow.fareTypeIndicator = fareTypeIndicator;
            if (row.category === 'TACTICAL' && entry[0].inventoryAssignmentMethod !== 'ENTRY LEVEL RBD' && entry[0].inventoryAssignmentMethod !== 'RBD TO RBD') {
              throw new Error('For TACTICAL category, Inventory Assignment Method must be ENTRY LEVEL RBD or RBD TO RBD');
            }
            propertyRow.competitorFareSource = entry[0].fareSource;
            propertyRow.fareTariffNumber = entry[0].fareTariffNumber;
            propertyRow.inventoryAssignmentMethod = entry[0].inventoryAssignmentMethod;
            propertyRow.ladderGenerationMethod = entry[0].ladderGenerationMethod;
            propertyRow.useForLadderGeneration = entry[0].useForLadderGeneration;
            propertyRow.hostEntryLevelRBD = entry[0].hostEntryLevelRBD.toUpperCase();
            if (!_.isEmpty(entry[0].hostFareBrand)) {
              propertyRow.hostFareBrand = entry[0].hostFareBrand;
            }
            propertyRow.competitorFareClassMappingList = getCompetitorFareClassMappingList(groupingByHostFareBrand[entry[0].hostFareBrand]);
            fareClassMappingProperties.push(propertyRow);
          });
        });
      });
    });
    row.fareClassMappingProperties = mergeFareClassMappingOnBasisOfFareSource(fareClassMappingProperties);
    return convertFOAttributeNameToAttributeName(row, 'fareClassMappingProperties');
  }
  function mergeFareClassMappingOnBasisOfFareSource(fareClassMappingProperties) {
    var mergedFareClassMapping = [];
    _.forEach(fareClassMappingProperties, function (eachFareClassMapping) {
      var merged = false;
      for (var i = 0; i < mergedFareClassMapping.length; i++) {
        var value = mergedFareClassMapping[i];
        if (isFareClassMappingPropertiesSameExceptFareSource(value, eachFareClassMapping)) {
          var fareSources = _.union(value.competitorFareSource.split(','), eachFareClassMapping.competitorFareSource.split(','));
          value.competitorFareSource = _.join(_.uniq(fareSources).sort());
          merged = true;
          break;
        }
      }
      if (!merged) {
        mergedFareClassMapping.push(eachFareClassMapping);
      }
    });
    return mergedFareClassMapping;
  }
  function isFareClassMappingPropertiesSameExceptFareSource(first, second) {
    return _.isEqual(first.fareTypeIndicator, second.fareTypeIndicator) && _.isEqual(first.inventoryAssignmentMethod, second.inventoryAssignmentMethod) && _.isEqual(first.ladderGenerationMethod, second.ladderGenerationMethod) && _.isEqual(first.useForLadderGeneration, second.useForLadderGeneration) && _.isEqual(first.hostEntryLevelRBD, second.hostEntryLevelRBD) && _.isEqual(first.hostFareBrand, second.hostFareBrand) && _.isEqual(first.competitorFareClassMappingList, second.competitorFareClassMappingList);
  }
  function getCompetitorFareClassMappingList(competitorMappingPerRbd) {
    var competitorFareClassMappingList = [];
    _.forEach(competitorMappingPerRbd, function (competitorMapping) {
      if (!areCompRbdsDefined(competitorMapping.competitorEntryLevelRbds)) {
        var competitorMappingRow = {};
        competitorMappingRow.competitorFareBrand = competitorMapping.competitorFareBrand;
        competitorMappingRow.competitorAirline = competitorMapping.competitorAirline.toUpperCase();
        competitorMappingRow.competitorEntryLevelRBD = null;
        competitorFareClassMappingList.push(competitorMappingRow);
      } else {
        var competitorEntryLevelRbds = competitorMapping.competitorEntryLevelRbds.toUpperCase().split(',');
        _.forEach(_.uniq(competitorEntryLevelRbds), function (competitorRbd) {
          var competitorMappingRow = {};
          competitorMappingRow.competitorFareBrand = competitorMapping.competitorFareBrand;
          competitorMappingRow.competitorAirline = competitorMapping.competitorAirline.toUpperCase();
          competitorMappingRow.competitorEntryLevelRBD = competitorRbd.toUpperCase();
          competitorFareClassMappingList.push(competitorMappingRow);
        });
      }
    });
    return _.uniqWith(competitorFareClassMappingList, _.isEqual);
  }
  function transformFORuleMappingDOWPayload(row) {
    return convertFOAttributeNameToAttributeName(row, 'ruleMappingDOWPropertiesList');
  }
  function transformFORuleMappingAPPayload(row) {
    return convertFOAttributeNameToAttributeName(row, 'ruleMappingAPPropertiesList');
  }
  function areCompRbdsDefined(compRbds) {
    return !_.isNil(compRbds);
  }
  function calculateSeatFactorForRow(row) {
    var availableCabins = configurationService.getCabins();
    var lowestCabin = _.last(availableCabins);
    var intermediateCabinData = [];
    _.forEach(row['curtainRuleParam_cabinOptions'], function (cabinOptionsRow) {
      _.forEach(availableCabins, function (cabinName) {
        if (cabinOptionsRow[CABIN_CAPACITIES_FIELD_PREFIX][cabinName] && cabinOptionsRow[CABIN_CAPACITIES_FIELD_PREFIX][lowestCabin] && cabinName !== lowestCabin) {
          var obj = {};
          obj[cabinName] = cabinOptionsRow[CABIN_CAPACITIES_FIELD_PREFIX][cabinName];
          obj[lowestCabin] = cabinOptionsRow[CABIN_CAPACITIES_FIELD_PREFIX][lowestCabin];
          if (!intermediateCabinData[cabinName]) {
            intermediateCabinData[cabinName] = [];
          }
          intermediateCabinData[cabinName].push(obj);
        }
      });
    });
    row['curtainRuleParam_physicalSeatFactors'] = calculateSeatFactor(intermediateCabinData, lowestCabin);
    return row;
  }
  function calculateSeatFactor(intermediateCabinData, lowestCabin) {
    var seatFactors = {};
    seatFactors[lowestCabin] = 1;
    _.forIn(intermediateCabinData, function (cabinData, cabinName) {
      if (cabinData.length === 1) {
        seatFactors[cabinName] = 1;
      } else {
        cabinData = _.sortBy(cabinData, [lowestCabin]);
        var prevOption = _.head(cabinData);
        cabinData = _.tail(cabinData);
        var cabinSeatFactors = [];
        _.forIn(cabinData, function (option) {
          if (option[cabinName] - prevOption[cabinName] !== 0) {
            cabinSeatFactors.push((prevOption[lowestCabin] - option[lowestCabin]) / (option[cabinName] - prevOption[cabinName]));
          }
          prevOption = option;
        });
        seatFactors[cabinName] = _.mean(cabinSeatFactors);
      }
    });
    return seatFactors;
  }
  function transformBooleanValues(row) {
    _.forOwn(row, function (value, key) {
      if (_.isBoolean(value)) {
        row[key] = transformBoolean(value);
      }
    });
  }
  function transformNumberAttributes(attributes, meta) {
    if (meta === 'DA_BookingVelocityPPSAdjustment') {
      _.forOwn(attributes, function (value, key) {
        if (key !== 'cabinCode' && key !== 'legOrigin' && key !== 'legDestination' && key !== 'travelDateBegin' && key !== 'travelDateEnd' && key !== 'bvDeviationType') {
          attributes[key] = _.toInteger(value);
        }
      });
    }
  }
  function isOverlapping(range1, range2) {
    var from1 = range1.start;
    var to1 = range1.stop;
    var from2 = range2.start;
    var to2 = range2.stop;
    return to1 >= from2 && from1 <= to2;
  }
  function checkOverlapping(entries) {
    for (var i = 0; i < entries.length; i++) {
      for (var j = i + 1; j < entries.length; j++) {
        if (isOverlapping(entries[i], entries[j])) {
          return true;
        }
      }
    }
    return false;
  }
  function buildTimeOfDayProperties(props, fieldName) {
    var inOrOutBoundType = fieldName === 'inboundTimeOfDayDefinition' ? 'IB' : 'OB';
    var timeOfDayDefinition = _.map(props[fieldName], function (tod) {
      return {
        inOrOutBoundType: inOrOutBoundType,
        start: tod['start'].toString(),
        stop: tod['stop'].toString()
      };
    });
    return timeOfDayDefinition;
  }
  function transformDAFareFloorPayload(row) {
    var transformedRow = _.clone(row);
    transformedRow.fareFloorCeilingParams = {
      minFare: transformedRow.minFare,
      maxFare: transformedRow.maxFare
    };
    delete transformedRow.minFare;
    delete transformedRow.maxFare;
    return transformedRow;
  }
  function transformDAFareFloor(attrs, props, meta) {
    return _.merge({
      minFare: _.get(props, 'fareFloorCeilingParams.minFare'),
      maxFare: _.get(props, 'fareFloorCeilingParams.maxFare')
    }, attrs, meta);
  }
  function transformFORuleMappingMaxStayPayload(row) {
    return convertFOAttributeNameToAttributeName(row, 'ruleMappingMaxStayPropertiesList');
  }
  function transformFORuleMappingFareTariffConfigurationPayload(row) {
    transformRuleMappingFareTariffProperties(row.ruleTariffMappingPropertiesList);
    return convertFOAttributeNameToAttributeName(row, 'ruleTariffMappingPropertiesList');
  }
  function transformFORoutingDefinitionPayload(row) {
    _.forEach(row.routingDefinitionPropertiesList, function (property) {
      property.competitorAirline = _.toUpper(property.competitorAirline);
      property.competitorFbcPattern = _.toUpper(property.competitorFbcPattern);
    });
    return convertFOAttributeNameToAttributeName(row, 'routingDefinitionPropertiesList');
  }
  function transformFORuleMappingMaxStay(attrs, props, meta) {
    return transformAttributeNameToFOAttributeName(attrs, props, meta);
  }
  function transformFORuleMappingFareTariffConfiguration(attrs, props, meta) {
    return transformAttributeNameToFOAttributeName(attrs, props, meta);
  }
  function transformFORoutingDefinition(attrs, props, meta) {
    return transformAttributeNameToFOAttributeName(attrs, props, meta);
  }
  function transformFORuleMappingMinStayPayload(row) {
    return convertFOAttributeNameToAttributeName(row, 'ruleMappingMinStayPropertiesList');
  }
  function transformFORuleMappingMinStay(attrs, props, meta) {
    return transformAttributeNameToFOAttributeName(attrs, props, meta);
  }
  function transformFOCancellationThreshold(attrs, props, meta) {
    return transformAttributeNameToFOAttributeName(attrs, props, meta);
  }
  function transformFOCancellationThresholdPayload(row) {
    return convertFOAttributeNameToAttributeName(row, 'cancellationThreshold');
  }
  function transformRuleMappingFareTariffProperties(propertyList) {
    _.forEach(propertyList, function (property) {
      property.competitorAirline = property.competitorAirline.toUpperCase();
    });
  }
  return {
    transformFpMarketConfigType: transformFpMarketConfigType,
    transformFpMarketConfigPayload: transformFpMarketConfigPayload,
    transformFpTodHubBankConfigPayload: transformFpTodHubBankConfigPayload,
    transformFpMetroMarketPayload: transformFpMetroMarketPayload,
    getBenchmarkCarriersForDelete: getBenchmarkCarriersForDelete,
    transformCurtainRuleType: transformCurtainRuleType,
    transformCurtainRulePayload: transformCurtainRulePayload,
    transformBooleanValues: transformBooleanValues,
    transformNumberAttributes: transformNumberAttributes,
    transformFOBusinessRulesType: transformFOBusinessRulesType,
    transformFOBusinessRulesPayload: transformFOBusinessRulesPayload,
    transformFOMarketList: transformFOMarketList,
    transformFOFareBrands: transformFOFareBrands,
    transformFOCabinClassConfig: transformFOCabinClassConfig,
    transformFOCabinClassConfigPayload: transformFOCabinClassConfigPayload,
    transformFOUpSellBuyDownConfigPayload: transformFOUpSellBuyDownConfigPayload,
    transformFOUpSellBuyDownConfig: transformFOUpSellBuyDownConfig,
    convertFOAttributeNameToAttributeName: convertFOAttributeNameToAttributeName,
    transformAttributeNameToFOAttributeName: transformAttributeNameToFOAttributeName,
    transformFORbdLevelFareThresholdPayload: transformFORbdLevelFareThresholdPayload,
    transformFONoticePeriodType: transformFONoticePeriodType,
    transformFONoticePeriodPayload: transformFONoticePeriodPayload,
    transformFOAdvancePurchaseGrouping: transformFOAdvancePurchaseGrouping,
    transformFOAdvancePurchaseGroupingPayload: transformFOAdvancePurchaseGroupingPayload,
    transformFOViaPoints: transformFOViaPoints,
    transformFOViaPointsPayload: transformFOViaPointsPayload,
    transformFOTotalFareCityAirportConversion: transformFOTotalFareCityAirportConversion,
    transformFOTotalFareCityAirportConversionPayload: transformFOTotalFareCityAirportConversionPayload,
    transformFOInputDataComparisonChecksType: transformFOInputDataComparisonChecksType,
    transformFOInputDataComparisonChecksPayload: transformFOInputDataComparisonChecksPayload,
    transformFORbdLevelFareThreshold: transformFORbdLevelFareThreshold,
    transformFOFareClassMapping: transformFOFareClassMapping,
    transformFOFareClassMappingPayLoad: transformFOFareClassMappingPayLoad,
    transformFOTaxOverride: transformFOTaxOverride,
    transformFOPosAnalystMapType: transformFOPosAnalystMapType,
    transformFOPosAnalystMapPayload: transformFOPosAnalystMapPayload,
    transformFOTacticalFBCPatternConfig: transformFOTacticalFBCPatternConfig,
    transformFOTacticalFBCPatternConfigPayload: transformFOTacticalFBCPatternConfigPayload,
    transformFOTacticalFareIndexType: transformFOTacticalFareIndexType,
    transformFOTacticalFareIndexPayload: transformFOTacticalFareIndexPayload,
    transformFOTacticalUserOverridesType: transformFOTacticalUserOverridesType,
    transformFOTacticalUserOverridesPayload: transformFOTacticalUserOverridesPayload,
    transformFOFareBrandAssignmentPayload: transformFOFareBrandAssignmentPayload,
    transformFORuleMappingDOWPayload: transformFORuleMappingDOWPayload,
    transformFOApplicableDateMapping: transformFOApplicableDateMapping,
    transformFOApplicableDateMappingPayload: transformFOApplicableDateMappingPayload,
    transformFOTacticalFareDefinitionPayload: transformFOTacticalFareDefinitionPayload,
    transformFOTacticalFareDefinition: transformFOTacticalFareDefinition,
    transformFOFareBrandAssignment: transformFOFareBrandAssignment,
    transformFORuleMappingDOW: transformFORuleMappingDOW,
    transformDAFareFloorPayload: transformDAFareFloorPayload,
    transformDAFareFloor: transformDAFareFloor,
    transformFOFareBasisCodePattern: transformFOFareBasisCodePattern,
    transformFOFareBasisCodePatternPayload: transformFOFareBasisCodePatternPayload,
    transformFORuleMappingMaxStayPayload: transformFORuleMappingMaxStayPayload,
    transformFORuleMappingFareTariffConfigurationPayload: transformFORuleMappingFareTariffConfigurationPayload,
    transformFORoutingDefinitionPayload: transformFORoutingDefinitionPayload,
    transformFORuleMappingMaxStay: transformFORuleMappingMaxStay,
    transformFORuleMappingFareTariffConfiguration: transformFORuleMappingFareTariffConfiguration,
    transformFORoutingDefinition: transformFORoutingDefinition,
    transformFORuleMappingMinStayPayload: transformFORuleMappingMinStayPayload,
    transformFORuleMappingMinStay: transformFORuleMappingMinStay,
    transformFOCancellationThresholdPayload: transformFOCancellationThresholdPayload,
    transformFOCancellationThreshold: transformFOCancellationThreshold,
    transformFORuleMappingAPPayload: transformFORuleMappingAPPayload,
    transformFORuleMappingAP: transformFORuleMappingAP,
    transformFORbdAssignment: transformFORbdAssignment,
    transformFORbdAssignmentPayload: transformFORbdAssignmentPayload
  };
};
AdvancedHepTransformationService.$inject = ['ConfigurationService', 'FpMarketConfigParsingService', 'MomentService', 'FeatureToggleService', 'ConfigurationParametersAdvancedService'];
module.exports = AdvancedHepTransformationService;